import Text from '../../../shared/Text'
import styles from './ListingsEmptyState.module.scss'
import { ListingsEmptyStateIllustration } from './ListingsEmptyStateIllustration'
import { FormattedMessage } from 'react-intl'

export const ListingsEmptyState = () => {
  return (
    <div className={styles.bodyWrapper}>
      <div className={styles.body}>
        <ListingsEmptyStateIllustration />
        <Text className={styles.headerText} align='center' size='m' weight='bold'>
          <FormattedMessage id='HomeSearch.listings.emptyState.title' defaultMessage='No homes match your search' />
        </Text>
        <div>
          <Text className={styles.descriptionTopText} align='center' variant='neutralCool' variantCount='700' size='s'>
            <FormattedMessage
              id='HomeSearch.listings.emptyState.tryZooming'
              defaultMessage='Try zooming out and adjusting filters'
            />
          </Text>
        </div>
      </div>
    </div>
  )
}
